import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { Route, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { AppContext } from '../../App';
import Button from '../../components/Button';
import Checkbox from '../../components/Checkbox';
import SimpleFooter from '../../components/SimpleFooter';
import SimpleHeader from '../../components/SimpleHeader';
import { MOCKED_DATA } from '../../debug/Debug';
import { CAC_TYPE } from '../../res/Constants';
import { login } from '../../service/AccountService';
import { dismissToast, toastError } from '../../ui/ToastHelper';
import styles from './login.module.scss';
import './login.scss';

// Validation function for required fields
const validateRequired = (value, message) => {
    return value ? undefined : message;
};

export default function Login(props) {
    const history = useHistory();
    const appContext = React.useContext(AppContext);
    const [rememberMe, setRememberMe] = React.useState(false);

    React.useEffect(() => {
        return () => {
            dismissToast();
        };
    }, []);

    const onRememberMeChange = () => {
        setRememberMe((curr) => !curr);
    };

    const onLogin = (event) => {
        const { username, password } = event;
        // Note: remember-me is NOT sent in this initial login call
        // It will be sent only when the OTP is verified
        const formData = {
            username: username,
            password: password
        };
        login(formData, (result) => {
            if (result.status === 200) {
                appContext.onCacTypeChange(CAC_TYPE.CROP);
                history.replace('/nav');
            } else if (result.response?.status === 401 &&
                result.response?.data?.type === '/errors/authentication/tfaNotEnabled') {
                // Redirect to 2FA setup page
                history.push({
                    pathname: '/setup-2fa',
                    state: {
                        uri: result.response?.data?.uri,
                        secret: result.response?.data?.secret,
                        sessionData: result.response?.data?.sessionData,
                        username: username,
                        password: password,
                        rememberMe: rememberMe
                    }
                });
            } else if (result.response?.status === 401 &&
                result.response?.data?.type === '/errors/authentication/otpMissing') {
                // Redirect to OTP verification page
                history.push({
                    pathname: '/verify-2fa',
                    state: {
                        sessionData: result.response?.data?.sessionData,
                        username: username,
                        password: password,
                        rememberMe: rememberMe
                    }
                });
            } else if (result.response?.status === 401 &&
                result.response?.data?.type === '/errors/authentication/badCredentials') {
                // Show error toast for bad credentials
                console.log('Bad credentials');
                toastError('Invalid username or password');
            } else {
                console.log('login failed', result);
            }
        });
    };

    return (
        <Route
            render={() => (
                <div className='h-100 login-page'>
                    <SimpleHeader />
                    <div className='row' id='body-container'>
                        <div className='col-12 col-sm-10 col-md-7 col-lg-4 col-xl-4 my-auto mx-auto'>
                            <div className='form-container'>
                                <h4>Enter your credentials</h4>
                                <Form
                                    onSubmit={onLogin}
                                    render={({ handleSubmit }) => (
                                        <form onSubmit={handleSubmit}>
                                            <LoginField
                                                name='username'
                                                type='text'
                                                placeholder='User'
                                                text='Username'
                                                autoComplete='current-password'
                                                validate={
                                                    MOCKED_DATA
                                                        ? undefined
                                                        : (value) => validateRequired(value, 'Empty username')
                                                }
                                            />
                                            <LoginField
                                                name='password'
                                                type='password'
                                                placeholder='Password'
                                                text='Password'
                                                autoComplete='current-password'
                                                validate={
                                                    MOCKED_DATA
                                                        ? undefined
                                                        : (value) => validateRequired(value, 'Empty password')
                                                }
                                            />
                                            <StyledCheckbox
                                                text='Remember access'
                                                isHorizontal={true}
                                                isSelected={rememberMe}
                                                onChange={onRememberMeChange}
                                            />
                                            <Button
                                                text='LOGIN'
                                                className={styles.loginBtn}
                                                type='submit'
                                            />
                                            <p>{rememberMe}</p>
                                        </form>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <SimpleFooter {...props} />
                </div>
            )}
        />
    );
}
class LoginField extends Component {
    state = {
        isOnFocus: false
    };

    onFocus = () => {
        this.setState({ isOnFocus: true });
    };

    onBlur = () => {
        this.setState({ isOnFocus: false });
    };

    render() {
        const { text, validate, ...fieldProps } = this.props;

        return (
            <Field name={fieldProps.name} validate={validate}>
                {({ input, meta }) => (
                    <div className='field-container'>
                        <label
                            style={
                                this.state.isOnFocus
                                    ? { fontWeight: 'bold', color: 'green' }
                                    : { fontWeight: 400, color: 'black' }
                            }>
                            {text}
                        </label>
                        <input
                            {...input}
                            className='input-field'
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            type={fieldProps.type}
                            placeholder={fieldProps.placeholder}
                            autoComplete={fieldProps.autoComplete}
                        />
                        {meta.error && meta.touched && (
                            <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
                        )}
                    </div>
                )}
            </Field>
        );
    }
}

const StyledCheckbox = styled(Checkbox)`
    height: 50px;
    padding-left: 25px;
    width: 80%;
`;
